import React from 'react';
import { Button, Space, Typography, Divider } from 'antd';
import { EnvironmentOutlined, AimOutlined } from '@ant-design/icons';
import { useSelection } from '../../contexts/SelectionContext';

const { Text, Title } = Typography;

const ZoneTooltip = ({ zoneName }) => {
  const { origin, destination, setOrigin, setDestination } = useSelection();

  const isCurrentOrigin = origin === zoneName;
  const isCurrentDestination = destination === zoneName;

  const handleSetOrigin = () => {
    if (isCurrentOrigin) {
      setOrigin(null);
    } else {
      // Clear any other selected city (both origin and destination)
      setOrigin(zoneName);
      setDestination(null);
    }
  };

  const handleSetDestination = () => {
    if (isCurrentDestination) {
      setDestination(null);
    } else {
      // Clear any other selected city (both origin and destination)
      setDestination(zoneName);
      setOrigin(null);
    }
  };

  return (
    <div className="zone-tooltip">
      <Title level={5} style={{ margin: 0, marginBottom: 8, color: '#333' }}>
        {zoneName}
      </Title>

      {(isCurrentOrigin || isCurrentDestination) && (
        <>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {isCurrentOrigin && 'Attualmente impostato come Origine'}
            {isCurrentDestination && 'Attualmente impostato come Destinazione'}
          </Text>
          <Divider style={{ margin: '8px 0' }} />
        </>
      )}

      <Space direction="vertical" style={{ width: '100%' }} size="small">
        <Button
          type={isCurrentOrigin ? 'primary' : 'default'}
          icon={<EnvironmentOutlined />}
          onClick={handleSetOrigin}
          block
          style={{
            backgroundColor: isCurrentOrigin ? '#4CAF50' : undefined,
            borderColor: isCurrentOrigin ? '#4CAF50' : undefined,
          }}
        >
          {isCurrentOrigin ? 'Rimuovi Origine' : 'Imposta come Origine'}
        </Button>

        <Button
          type={isCurrentDestination ? 'primary' : 'default'}
          icon={<AimOutlined />}
          onClick={handleSetDestination}
          block
          style={{
            backgroundColor: isCurrentDestination ? '#2196F3' : undefined,
            borderColor: isCurrentDestination ? '#2196F3' : undefined,
          }}
        >
          {isCurrentDestination ? 'Rimuovi Destinazione' : 'Imposta come Destinazione'}
        </Button>
      </Space>
    </div>
  );
};

export default ZoneTooltip;
